<template>
  <Validator label="" :v="v" input>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
          <div class="custom-input" >
            <div
              :class="{
                'outline-block': true,
                'outline-block--focus': inputFocus,
                'outline-border-error': v.$invalid && v.$dirty || validation
              }">
              <input
                :aria-label="montarLabelAria()"
                :type="'text'"
                v-mask="'##/##/####'"
                :class="{ 'outline-border-error': (v.$invalid && v.$dirty) || validation, 'outline-input': true }"
                style="min-heigth: 15px; font-size: 14px;"
                :disabled="disabled"
                :readonly="readonly"
                :required="required"
                :placeholder="placeholder"
                :maxlength="maxlength()"
                :max="tratarMax()"
                :min="min"
                :value="value"
                :step="step"
                @input="onInput"
                @change="$emit('change')"
                @click="$emit('click')"
                @focus="onFocus"
                @blur="onBlur"
                @keyup="$emit('keyup')"
                @keydown="$emit('keydown')"
                ref="input"
                @keypress="onKeyPress" />
                <div
                  :class="{
                    'outline-label' : true,
                    'outline-label-up': value || inputFocus || type == 'date' || type == 'time' || type == 'datetime-local' || placeholder,
                    'outline--focus': inputFocus,
                    'outline-error': v.$invalid && v.$dirty
                  }">
                  {{ montarLabel() }}
                </div>
                <div class="outline-disabled" style="font-size: 14px;"></div>
                <v-icon tabindex="-1" aria-label="botão abrir calendário" :disabled="disabled" v-on="on" v-bind="attrs" class="outline-icon-right" style="font-size: 13px;font-weight: 600; color: rgba(0,0,0,.70); width: 40px; z-index: 99;">calendar_today</v-icon>
            </div>
          </div>
      </template>
      <v-date-picker
        locale="pt-br"
        v-model="date"
        @input="datePickerInput"
      ></v-date-picker>
    </v-menu>

  </Validator>
</template>

<script>
import Validator from './Valitador.vue';
import moment from 'moment'

export default {
  inheritAttrs: false,
  nome: 'InputDate',
  components: {
    Validator,
  },
  props: {
    type: String,
    label: {
      type: String,
      default: '',
    },
    placeholder: String,
    // iconRight: String ,
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number
    },
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $params: [],
          $touch: () => {},
        };
      },
    },
    step: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      inputFocus: false,
      menu: false,
      date: '',
    };
  },
  methods: {
    datePickerInput(event) {
      this.menu = !this.menu
      const dataFormatted = this.parseDateDDMMYYYY(this.date)
      // this.value = dataFormatted;
      // this.$emit('input', this.value);
      this.$emit('input', dataFormatted);
    },
    onInput(event) {
      if (this.maxlength()) { event.target.value = event.target.value.substring(0, this.maxlength()); }
     // this.value = event.target.value;
      this.$emit('input', event.target.value);
      this.date = this.parseDateYYYYMMDD(this.value)
    },
    onFocus() {
      this.inputFocus = true;
      this.$emit('focus');
    },
    onBlur() {
      this.v.$touch();
      this.inputFocus = false;

     if (this.type == 'date' && this.value == '') { this.$emit('input', ''); }
     this.$emit('blur');
    },
    maxlength() {
      if (typeof this.v.$params.maxLength === 'undefined') { return; }

      return this.v.$params.maxLength.max;
    },
    onKeyPress(event) {
      this.$emit('keypress');
    },
    tratarMax() {
      if (this.type == 'date') { return '2999-12-31'; }
    },
    montarLabel() {
      return `${this.label}${(typeof this.v.$params.required !== 'undefined' && this.v.$params.required != null && this.label !== '') ? '*' : ''}`;
    },
    montarLabelAria() {
      let  removeAsterisco = this.montarLabel();      
      if (removeAsterisco.endsWith("*")) {
        removeAsterisco = removeAsterisco.slice(0,-1) + ". Campo Obrigatório ";
      } 
      return removeAsterisco;
    },    
    parseDateDDMMYYYY(date) {
      if(date.length < 10) return date
      if (!date) return ''

      const [year, month, day] = date.split('-')
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;

    },
    parseDateYYYYMMDD(date) {
      if(date.length < 10) return date
      if (!date) return ''

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

    },

  },
};
</script>

<style lang="scss">
@import '@/assets/css/input.scss';
</style>
